import { FC } from "react";
import { useTranslation } from "react-i18next";

import {
  getPassengerSexColor,
  NO_VALUE_DISPLAY,
  PassengerSexEnum,
} from "@ryde/shared";

import { CellSimple } from "../../../../grid";
import { GenderDotStyled } from "./ride-stations.styled";

interface IProps {
  isGenderDistinctionEnabled: boolean;
  sex: PassengerSexEnum | undefined;
}

export const PassengerGenderCell: FC<IProps> = ({
  isGenderDistinctionEnabled,
  sex,
}) => {
  const { t } = useTranslation();

  if (!isGenderDistinctionEnabled) {
    return null;
  }

  return (
    <div className="column_gender">
      {sex ? (
        <>
          <GenderDotStyled
            $color={getPassengerSexColor({
              sex,
              isSelected: true,
              isGenderDistinctionEnabled: true,
            })}
          />
          <CellSimple tooltipDisabled={true}>
            {t(`selectListLabel.${sex}`)}
          </CellSimple>
        </>
      ) : (
        <CellSimple tooltipDisabled={true}>{NO_VALUE_DISPLAY}</CellSimple>
      )}
    </div>
  );
};
